import { Component } from '@angular/core';
import { timeApi } from './services/constants/api.constants';
import {
  ACCESS_TOKEN,
  AuthService,
  HelpersService,
  LanguageService,
  HttpBaseService,
  ScriptInjectorService,
  DEFAULT_LANGUAGE,
} from '@evento-ng/libs';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private languageService: LanguageService,
    private helpers: HelpersService,
    private authService: AuthService,
    private dataService: HttpBaseService,
    private scriptInjectorService: ScriptInjectorService
  ) {
    let lang = 'ar';
    try {
      const storedLang = localStorage.getItem(DEFAULT_LANGUAGE);
      if (storedLang) {
        try {
          const parsedLang = JSON.parse(storedLang);
          if (parsedLang === 'ar' || parsedLang === 'en') {
            lang = parsedLang;
          } else {
            localStorage.setItem(DEFAULT_LANGUAGE, JSON.stringify(lang));
          }
        } catch {
          localStorage.setItem(DEFAULT_LANGUAGE, JSON.stringify(lang));
        }
      } else {
        localStorage.setItem(DEFAULT_LANGUAGE, JSON.stringify(lang));
      }
    } catch (e) {
      console.warn('Error accessing localStorage for language', e);
      localStorage.setItem(DEFAULT_LANGUAGE, JSON.stringify(lang));
    }

    const originalLoadStyle = this.languageService['loadStyle'].bind(
      this.languageService
    );
    this.languageService['loadStyle'] = (styleName: string) => {
      if (!styleName) return;
      const head = document.getElementsByTagName('head')[0];
      if (!head) return;
      let styleLink = document.getElementById(
        'client-theme'
      ) as HTMLLinkElement;
      if (!styleLink) {
        styleLink = document.createElement('link');
        styleLink.id = 'client-theme';
        styleLink.rel = 'stylesheet';
        head.appendChild(styleLink);
      }
      styleLink.href = `assets/styles/${styleName}`;
    };

    this.languageService.loadDefaultLangsAndStyles();
    if (
      this.helpers.checkItemFromLocalStorage(ACCESS_TOKEN) &&
      !this.authService.user.getValue()
    ) {
      this.authService.fetchUser();
    }
    if (environment.production) {
      this.scriptInjectorService.injectGtm();
    }
  }

  ngOnInit() {
    this.getServerTime();
  }

  getServerTime() {
    this.dataService.get(timeApi).subscribe((res) => {
      const serverTime = Math.floor(res.currentTime);
      const now = Math.floor(Date.now() / 1000) - 5;
      localStorage.setItem('serverDiff', JSON.stringify(serverTime - now));
    });
  }
}
